import colors from 'assets/theme/base/colors';

const svgIcon = {
    defaultProps: {
        //fontSize: 'inherit',
    },

    styleOverrides: {
        root: {
            '&.Mui-disabled': {
                fill: colors.grey[500],
            },
        },

        /*fontSizeInherit: {
            fontSize: 'inherit',
        },

        fontSizeSmall: {
            fontSize: typography.size.xxxxl,
        },*/

        /*fontSizeLarge: {
            fontSize: typography.size.sevenXl,
        },
        fontSizeMedium: {
            fontSize: typography.size.fiveXl,
        },*/
        /*fontSizeSmall: {
            fontSize: typography.size.xl,
        },*/
    },
};

export default svgIcon;
